// extracted by mini-css-extract-plugin
export default {"tag":"mqeYqD","mobile":"j7hYeR"};